import { IsNotEmpty, IsNumberString, MaxLength, Validate, IsDefined } from 'class-validator';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { DisplayNameValidation } from 'src/core/customValidator/displayNameValidator';

export class PlaceDataService extends DataService<typeof Model.General.Logic.ViewModels.PlaceItem, Model.General.Logic.ViewModels.PlaceItem, PlaceItem> {
	protected map(entity: Model.General.Logic.ViewModels.PlaceItem): PlaceItem {
		return new PlaceItemModel(entity);
	}

	public static make(ctx?: any): PlaceDataService {
		return new PlaceDataService(ctx, ctx => ctx.Places);
	}
	getType(type: string) {
		switch (type) {
			case 'General':
				return 0;
			case 'Resort':
				return 2;
			case 'TransferPoint':
				return 3;
			case 'CoachPickupPoint':
				return 4;
		}
	}
	add(defaultLanguage: string, type?:string) {
		const entity = new Model.General.Logic.ViewModels.PlaceItem();
		(entity as any).dynamicProperties['displayName'] = { [defaultLanguage]: '' };
		entity.type = this.getType(type);
		return entity;
	}
}

export class PlaceItemModel extends EntityModel<Model.General.Logic.ViewModels.PlaceItem, PlaceItem> implements PlaceItem {
	@property<PlaceItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<PlaceItemModel>(o => o.entity.regionId, (o, value) => o.entity.regionId = value)
	public regionId: number;

	@property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
	@Validate(DisplayNameValidation, ['en'])
	public dynamicProperties: {};

	@property<PlaceItemModel>(o => o.entity.type, (o, value) => o.entity.type = value)
	public type: number;

	@property<PlaceItemModel>(o => o.entity.location, (o, value) => o.entity.location = value)
	public location: any;
	@property<PlaceItemModel>(o => o.entity.parentPlaceId, (o, value) => o.entity.parentPlaceId = value)
	public parentPlaceId?: number;

}



// WEBPACK FOOTER //
// ./src/app/general/places/form/place-form.data.ts